import type { ConfigVehicleDetails, Selectors } from '@makemydeal/dr-activities-vehicle-details';
import { init } from '@makemydeal/dr-activities-vehicle-details';
import { APP_NAME } from './constants';
import { additionalSelectors } from './additionalSelectors';
import { hostActions } from './hostActions';

export let vehicleDetailsSelectors: Selectors;

export const configureVehicleDetails = (config: ConfigVehicleDetails): Selectors => {
    const { selectors } = init(APP_NAME, additionalSelectors, hostActions, config);
    vehicleDetailsSelectors = selectors;
    return selectors;
};

export const getVehicleDetailsSelectors = (): Selectors => vehicleDetailsSelectors;
